import React from 'react';
import { FormLoadingErrorBanner } from './form-loading-error-banner';
import { FormLoadingIndicator } from './form-loading-indicator';
import { useIntegratedForm } from '../use-integrated-form';
import { FocusScope } from '@react-aria/focus';
import { FormSavingErrorBanner } from './form-saving-error-banner';

const FormBodyInner = React.memo(function FormBodyInner(props: {
    children: React.ReactElement;
    style?: React.CSSProperties;
    onKeyDown?: React.KeyboardEventHandler<HTMLFormElement>;
    focusForm?: boolean;
}): React.ReactElement {
    const { focusForm } = props;
    const integratedForm = useIntegratedForm();
    return !integratedForm.query.isInitialLoading && !integratedForm.query.isError ? (
        <FocusScope autoFocus={focusForm !== undefined ? focusForm : true}>
            <form
                data-testid="form-body"
                onKeyDown={(e) => {
                    if (e.key === 'Enter' && !(e.target instanceof HTMLTextAreaElement)) {
                        e.preventDefault();
                    }
                    props.onKeyDown?.(e);
                }}
                style={props.style}
            >
                {props.children}
            </form>
        </FocusScope>
    ) : (
        <></>
    );
});

export function FormBody(props: {
    loadingErrorMessage?: string;
    saveErrorMessage?: string;
    onKeyDown?: React.KeyboardEventHandler<HTMLFormElement>;
    formBodyStyle?: React.CSSProperties;
    children: React.ReactElement;
    focusForm?: boolean;
}): React.ReactElement {
    return (
        <>
            <FormLoadingIndicator />
            <FormLoadingErrorBanner title={props.loadingErrorMessage} />
            <FormSavingErrorBanner title={props.saveErrorMessage} />
            <FormBodyInner
                style={props.formBodyStyle}
                onKeyDown={props.onKeyDown}
                focusForm={props.focusForm}
            >
                {props.children}
            </FormBodyInner>
        </>
    );
}
